import React, { useMemo, useRef } from 'react'
import { useForgotPasswordMutation } from '../../../app/services/authAPI';
import { removeCookie } from '../../../utils/Cookies/CookieHandler';
import ResetPasswordFormData from './config/ResetPassword.data';
import Buttons from '../../../components/ui/button/Buttons';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import FormCreator from "../../../components/finalForms/FormCreator";
import { AppIcons } from '../../../data/appIcons';
import ToastService from '../../../services/toastService/ToastService';
import { decryptUrlData } from '../../../services/CryptoService';


const ResetPasswordMain = () => {
  const resetpassref = useRef();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const Id = useMemo(() => {
    try { return Number(decryptUrlData(id)); } catch { return 0; }
  }, [id]);

  const config = useMemo(() => ({
    ...ResetPasswordFormData,
    initialState: {
      ...ResetPasswordFormData.initialState,
      temporaryPassword: location.state?.temporaryPassword || '',
    },
  }), [location.state?.temporaryPassword]);

  const [forgotPassword, { isLoading: isResetting }] = useForgotPasswordMutation();

  const handalResetData = async () => {
    if (!Number.isInteger(Id) || Id <= 0) {
      ToastService.error('Invalid reset link. Please request a new password reset email.');
      return;
    }
    if (isResetting) return;
    const UserData = resetpassref.current.getFormData();

    if (UserData && UserData.password === UserData.Confirmpassword) {
      const request = {
        ...UserData,
        temporaryPassword: UserData.temporaryPassword?.trim(),
        userId: Id
      }
      try {
        const result = await forgotPassword(request).unwrap();
        if (!(result?.keyValue > 0) || /no user found/i.test(result?.errorMessage || '')) {
          ToastService.error(result?.errorMessage || 'Password could not be updated.');
          return;
        }
        removeCookie('rememberMe');
        ToastService.success('Password updated successfully. Please log in with your new password.');
        navigate('/login');
      } catch {
        ToastService.error('Password could not be updated. Please try again.');
      }
    }
    else if (UserData && UserData.password !== UserData.Confirmpassword) {
      ToastService.error("Password does not match")
    }
  }


  return (
    <div className="login-form-section">
      <p>Copy the temporary password from your latest reset email into the first field. Do not enter your email address or your new password there.</p>
      <FormCreator
        ref={resetpassref} config={config}
      />

      <div className="button-part">
        <Buttons
          buttonTypeClassName="theme-btn"
          imagePath={AppIcons.addIcon}
          buttonText="Submit"
          onClick={handalResetData}
          isLoading={isResetting}
        />
      </div>
    </div>

  )
}
export default ResetPasswordMain;
